import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { ButtonPrimary } from '../../components/formelements';
import MemoDestinationsDDL from '../../components/memoDestinationsDDL';
import { valdiatePage, getSession, processStrWithSpace, processInt, processEmail, processNum, processStr } from '../../global';
import { reverseCNInfo, saveReversePickup } from '../../services/bookingservice';
import { getSubAccountLocations } from '../../services/userservice';
import { setLoading } from '../../redux/appSlice';
import './reversepickup.css';

const ReversePickup = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { userInfo, destinations, accounts, subaccounts } = useSelector(state => state.appData);

    const destRef = useRef(null);
    const d = {
        cn: '',
        cnType: '12',
        consignee: '',
        consigneeAddress: '',
        consigneePhone: '',
        //alternateConsigneePhone: '',
        consigneeEmail: '',
        shipper: '',
        shipperAddress: '',
        shipperPhone: '',
        origin: '',
        destination: '',
        pcs: '',
        serviceType: 'Reversal COD',
        weight: '',
        productDetails: '',
        remarks: '',
        refNo: '',
        codAmount: '0',
        shs: false,
        departmentCostCenter: '',
        locationId: '',
        subAccountId: '',
        accountNo: '',
        isCod: true,
        autoCN: true
    };
    const [data, setData] = useState(d);
    const sd = {
        cn: '',
        refno: ''
    };
    const [searchData, setSearchData] = useState(sd);
    const [locations, setLocations] = useState([]);

    useEffect(() => {
        if (!valdiatePage('/reversepickup')) {
            history.push('/login');
        }
    }, []);

    const updateData = (key, val) => setData(prevState => { return { ...prevState, [key]: val }; });
    const updateSearchData = (key, val) => setSearchData(prevState => { return { ...prevState, [key]: val }; });

    const reset = () => {
        setData(d);
        destRef.current.selectedIndex = 0;
    }

    const validate = () => {
        if (!data.shipper || data.shipper.trim() === '') {
            alert('Customer Name is required');
            return false;
        }

        if (!data.shipperPhone) {
            alert('Customer Mobile is required');
            return false;
        } else {
            // if (data.shipperPhone.length <= 11) {
            //     alert('Customer Mobile is Invalid');
            //     return false;
            // }
        }

        if (!data.origin) {
            alert('Pickup Origin is required');
            return false;
        }

        if (!data.shipperAddress || data.shipperAddress.trim() === '') {
            alert('Pickup Address is required');
            return false;
        }

        if (!data.subAccountId) {
            alert('Sub Account is required');
            return false;
        }

        if (!data.locationId) {
            alert('Location is required');
            return false;
        }

        if (!data.consigneePhone) {
            alert('Mobile No is required');
            return false;
        } else {
            if (data.consigneePhone.length < 11) {
                alert('Mobile No is Invalid');
                return false;
            }
        }

        // if (!!data.alternateConsigneePhone.length && data.alternateConsigneePhone.length < 11) {
        //     alert('Alternate Mobile No is Invalid');
        //     return false;
        // }

        if (data.consigneeEmail.trim() && !data.consigneeEmail.includes('@')) {
            alert('Consignment Email is invalid');
            return false;
        }

        if (!data.consigneeAddress || data.consigneeAddress.trim() === '') {
            alert('Consignment Address is required');
            return false;
        }

        if (!data.weight || data.weight <= 0) {
            alert('Weight is required');
            return false;
        } else {
            if (data.weight > 99) {
                alert('Weight is greater than 99');
                return false;
            }
        }

        if (!data.pcs || data.pcs <= 0) {
            alert('Pieces is required');
            return false;
        }

        if (!data.refNo) {
            alert('Ref No is required');
            return false;
        }

        return true;
    }

    const onSearch = async () => {
        if ((!searchData.cn || searchData.cn.trim() === '') && (!searchData.refno || searchData.refno.trim() === '')) {
            alert('Enter Consignment No or Ref No');
            return;
        }
        const z = {
            accounts: accounts,
            cn: searchData.cn,
            refNo: searchData.refno
        }
        dispatch(setLoading({ data: true }));
        const rs = await reverseCNInfo(z);
        dispatch(setLoading({ data: false }));
        if (rs.sts == 0 && rs.data) {
            const dsAvailable = destinations.filter(x => x.value == Number(rs.data.origin));
            const {
                customer,
                customerPhone,
                customerAddress,
                origin,
                weight,
                pcs,
                refNo,
                remarks,
                productDetails
            } = rs.data;
            setData({ ...d, shipper: customer, shipperPhone: customerPhone, shipperAddress: customerAddress, weight: weight, pcs: pcs, refNo: refNo, remarks: remarks, productDetails: productDetails, origin: dsAvailable.length > 0 ? origin : '' })
            destRef.current.value = dsAvailable.length > 0 ? origin : '';
        } else {
            alert(rs.msg);
        }
    }

    const onSave = async (e) => {
        if (validate()) {
            const z = {
                "cnType": data.cnType,
                "consignee": data.consignee,
                "consigneeAddress": data.consigneeAddress,
                "consigneePhone": data.consigneePhone,
                //"alternateConsigneePhone": data.alternateConsigneePhone,
                "consigneeEmail": data.consigneeEmail,
                "shipper": data.shipper,
                "shipperAddress": data.shipperAddress,
                "shipperPhone": data.shipperPhone,
                "origin": String(data.origin),
                "destination": data.destination,
                "pcs": data.pcs,
                "serviceType": data.serviceType,
                "weight": data.weight,
                "productDetails": data.productDetails,
                "remarks": data.remarks,
                "refNo": data.refNo,
                "shs": data.shs,
                "user": {
                    "id": userInfo.id,
                    "isDuplicateOrderAllowed": userInfo.isDuplicateOrderAllowed
                },
                "locationId": data.locationId,
                "subAccountId": data.subAccountId,
                "autoCN": data.autoCN,
                "accountNo": data.accountNo
            };
            dispatch(setLoading({ data: true }));
            const rs = await saveReversePickup(z);
            dispatch(setLoading({ data: false }));
            alert(rs.msg);
            if (rs.ok) {
                reset();
            }
        }
    }

    return getSession('userInfo') && <section className="section">
        <div className="section-header">
            <h1>Reverse Pickup</h1>
        </div>
        <div className="card" style={{ padding: 10 }}>
            <div className="row mb-5">
                <div className="col-lg-3 col-sm-12">
                    <label>Consignment No</label>
                    <input type="text" maxLength={15} onInput={processInt} className="form-control" value={searchData.cn} onChange={e => updateSearchData('cn', e.target.value)} />
                </div>
                <div className="col-lg-3 col-sm-12">
                    <label>Ref No</label>
                    <input type="text" maxLength={15} onInput={processStr} className="form-control" value={searchData.refno} onChange={e => updateSearchData('refno', e.target.value)} />
                </div>
                <div className="col">
                    <ButtonPrimary text="Search" onClick={onSearch} style={{ marginTop: '1.5rem' }} />
                </div>
            </div>
            <fieldset>
                <legend>Pickup Information</legend>
                <div className="row">
                    <div className="col-lg-3 col-sm-12">
                        <label>Customer Name</label>
                        <input type="text" maxLength={50} onInput={processStrWithSpace} className="form-control" value={data.shipper} onChange={e => updateData('shipper', e.target.value)} />
                    </div>
                    <div className="col-lg-3 col-sm-12">
                        <label>Mobile No</label>
                        <input type="text" className="form-control" maxLength={11} onInput={processInt} value={data.shipperPhone} onChange={e => updateData('shipperPhone', e.target.value)} />
                    </div>
                    <div className="col-lg-3 col-sm-12">
                        <label>Pickup Origin</label>
                        <MemoDestinationsDDL destRef={destRef} label="Pickup Origin" destinations={destinations} onChange={(e) => updateData('origin', e.target.value)} />
                    </div>
                    <div className="col-lg-3 col-sm-12">
                        <label>Pickup Address</label>
                        <textarea className="form-control" value={data.shipperAddress} maxLength={200} onInput={processStrWithSpace} onChange={e => updateData('shipperAddress', e.target.value)}></textarea>
                    </div>
                </div>
            </fieldset>
            <fieldset className="mt-3">
                <legend>Return Information</legend>
                <div className="row">
                    <div className="col-lg-3 col-sm-12">
                        <label>Sub Account</label>
                        <select className="form-select" value={data.subAccountId} onChange={async (e) => {
                            const val = e.target.value;
                            const accno = e.target[e.target.selectedIndex].getAttribute('data-accno');
                            const name = e.target[e.target.selectedIndex].getAttribute('data-name');
                            setData({ ...data, subAccountId: val, locationId: '', accountNo: accno, consignee: name });
                            if (val) {
                                const locs = await getSubAccountLocations(userInfo.id, val)
                                if (locs)
                                    setLocations(locs);
                            } else {
                                setLocations([]);
                            }
                        }}>
                            <option value="" data-accno="" data-name="">Select Sub Account</option>
                            {
                                subaccounts.filter(x => x.isCod && x.autoCN).map((x, index) => <option key={index} value={x.id} data-name={x.shipperName} data-accno={x.accountNo}>{x.name}</option>)
                            }
                        </select>
                    </div>
                    <div className="col-lg-3 col-sm-12">
                        <label>Locations</label>
                        <select className="form-select" value={data.locationId} onChange={(e) => {
                            const val = e.target.value;
                            const addr = e.target[e.target.selectedIndex].getAttribute('data-addr');
                            const branch = e.target[e.target.selectedIndex].getAttribute('data-branch');
                            setData({ ...data, locationId: val, consigneeAddress: addr, destination: branch });
                        }}>
                            <option value="" data-addr="" data-branch="">Select Location</option>
                            {
                                locations.filter(x => x.isCod).map((x, index) => <option key={index} data-addr={x.locationAddress} data-branch={x.branch} value={x.value}>{x.text}</option>)
                            }
                        </select>
                    </div>
                    <div className="col-lg-3 col-sm-12">
                        <label>Mobile</label>
                        <input type="text" className="form-control" maxLength={11} onInput={processInt} value={data.consigneePhone} onChange={e => updateData('consigneePhone', e.target.value)} />
                    </div>
                    {/* <div className="col-lg-3 col-sm-12">
                        <label>Alternate Mobile</label>
                        <input type="text" className="form-control" maxLength={11} onInput={processInt} value={data.alternateConsigneePhone} onChange={e => updateData('alternateConsigneePhone', e.target.value)} />
                    </div> */}
                </div>
                <div className="row mt-2">
                <div className="col-lg-3 col-sm-12">
                        <label>Email</label>
                        <input type="text" className="form-control" maxLength={50} onInput={processEmail} value={data.consigneeEmail} onChange={e => updateData('consigneeEmail', e.target.value)} />
                    </div>
                    <div className="col-lg-3 col-sm-12">
                        <label>Return Address</label>
                        <textarea className="form-control" value={data.consigneeAddress} maxLength={200} onInput={processStrWithSpace} onChange={e => updateData('consigneeAddress', e.target.value)}></textarea>
                    </div>
                </div>
            </fieldset>
            <fieldset className="mt-3">
                <legend>Shipment Information</legend>
                <div className="row">
                    <div className="col-lg-3 col-sm-12">
                        <label>Weight</label>
                        <input type="text" className="form-control" maxLength={4} onInput={processNum} value={data.weight} onChange={e => updateData('weight', e.target.value)} />
                    </div>
                    <div className="col-lg-3 col-sm-12">
                        <label>Pieces</label>
                        <input type="text" className="form-control" maxLength={4} onInput={processNum} value={data.pcs} onChange={e => updateData('pcs', e.target.value)} />
                    </div>
                    <div className="col-lg-3 col-sm-12">
                        <label>Ref No</label>
                        <input type="text" className="form-control" value={data.refNo} onInput={processStr} onChange={e => updateData('refNo', e.target.value)} />
                    </div>
                    <div className="col-lg-3 col-sm-12">
                        <label>Special Handling</label>
                        <select className="form-select" value={data.shs ? 1 : 0} onChange={e => updateData('shs', e.target.value == 1)} >
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col-lg-3 col-sm-12">
                        <label>Product Details</label>
                        <textarea className="form-control" value={data.productDetails} onChange={e => updateData('productDetails', e.target.value)}></textarea>
                    </div>
                    <div className="col-lg-3 col-sm-12">
                        <label>Remarks</label>
                        <textarea className="form-control" value={data.remarks} onChange={e => updateData('remarks', e.target.value)}></textarea>
                    </div>
                </div>
            </fieldset>
            <div className="row mt-2">
                <div className="col-12" style={{ textAlign: 'right' }}>
                    <ButtonPrimary text="Save" onClick={onSave} />
                </div>
            </div>
        </div>
    </section>
}

export default ReversePickup;
